// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"0681e2b9","556":"e208e174","606":"25b94d95"}[chunkId] + ".chunk.css";
};